<!-- 采购合同列表——新增或修改、查看（procurementContract） -->
<template>
  <div>
    <div class="demo-drawer__content data_action_form">
      <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
        <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
          :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
          <template slot="tabs" slot-scope="scope">
            <div class="table_content_box">
              <!-- 主要信息 -->
              <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                <el-form label-width="100px" :disabled="dataActionBox.actionType == 2" id="mainInfo" class="baseForm"
                  :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                  <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                      :rules="formOneValue.isRequired == 1 && formOneValue.showField != '是否有明细' ? [{ required: true, trigger: ['blur', 'change'] }] : []"
                      :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                      :key="formOneKey">
                      <!-- 系统字段 -->
                      <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                        v-html="$common.htmlLabel(formOneValue.showField)"></label>
                      <!-- 是否有订单 -->
                      <el-switch class="form_codition" v-if="formOneValue.entityField == 'isDetail'" title="switch"
                        @change="changeOrder" :disabled="isChange" v-model="isShowDetail">
                      </el-switch>
                      <el-select class="form_codition" v-else-if="formOneValue.entityField == 'conmType'"
                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                        <el-option v-for="item in dictionariesData.CGHTLX" :key="item.diValue" :label="item.diName"
                          :value="item.diValue">
                        </el-option>
                      </el-select>
                      <!-- 普通日期 -->
                      <el-date-picker class="form_codition" v-else-if="formOneValue.fieldType == 'date'"
                        @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                        format="yyyy 年 MM 月 dd 日" value-format="timestamp" style="width:193px" type="date"
                        :placeholder="'选择' + formOneValue.showField"
                        :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                      </el-date-picker>
                      <!-- 检索方案 -->
                      <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input v-if="formOneValue.fieldType == 'search'" class="form_codition" clearable
                          v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                          :id="formOneValue.entityField"
                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                          :disabled="formOneValue.isChange == 0">
                          <el-button
                            @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                            slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0"></el-button>
                        </el-input>
                      </el-tooltip>
                      <!-- 提取方案 -->
                      <el-input class="form_codition" v-else-if="formOneValue.fieldType == 'extract'" clearable
                        v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                        :id="formOneValue.entityField"
                        @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                        :disabled="formOneValue.isChange == 0">
                        <el-button
                          @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                          slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0">
                        </el-button>
                      </el-input>
                      <el-input class="form_codition" @input="$forceUpdate()"
                        @keyup.enter.native="nextFocus(formOneKey)" v-else
                        v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                      </el-input>
                    </el-form-item>
                  </el-row>
                  <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                      :rules="formOneValue.isRequired == 1 && formOneValue.showField != '是否有明细' ? [{ required: true, trigger: ['blur', 'change'] }] : []"
                      :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                      :key="formOneKey">
                      <!-- 系统字段 -->
                      <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                        v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                      <!-- 是否有订单 -->
                      <el-switch class="form_codition" v-if="formOneValue.entityField == 'isDetail'" title="switch"
                        :disabled="true" v-model="isShowDetail">
                      </el-switch>
                      <span v-else-if="formOneValue.fieldType == 'date'">
                        <span v-if="sendDataInfo[formOneValue.entityField]">
                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                        </span>
                      </span>
                      <span v-else-if="formOneValue.entityField == 'conmType'">
                        <span v-for="item in dictionariesData.CGHTLX" :key="item.diValue"
                          v-if="item.diValue == sendDataInfo[formOneValue.entityField]">{{ item.diName }}</span>
                      </span>
                      <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                        getValue(sendDataInfo[formOneValue.entityField],
                          formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent) }}</span>
                      <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                    </el-form-item>
                  </el-row>
                </el-form>
                <el-form :inline="true" size="mini" v-if="isShowDetail">
                  <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                    <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增明细</el-button>
                    <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                  </div>
                  <el-table size="mini" class="baseTable" ref="mxTableRef" :data="sendDataInfo.detailList"
                    :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                    @selection-change="handleSelectionChange" :height="mxHeight" border style="width: 100%">
                    <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                      <template slot-scope="scope">
                        <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                          <i class="el-icon-thumb"></i>
                        </el-radio>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField"
                      show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                      v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                      <template slot-scope="scope">
                        <!-- 显示通用名称 -->
                        <el-input :ref="formOneValue.entityField"
                          v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2" clearable
                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField)"
                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                          <el-button
                            @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField)"
                            slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        <!-- 数量 num-->
                        <el-input v-else-if="formOneValue.entityField == 'num' && dataActionBox.actionType != 2"
                          :ref="formOneValue.entityField"
                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" type="number"
                          min="0" @input="calculatePrice(3, scope.$index)">
                        </el-input>
                        <!-- 含税价格 psprice-->
                        <el-input v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2"
                          :ref="formOneValue.entityField"
                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" type="number"
                          min="0" @input="calculatePrice(1, scope.$index)">
                        </el-input>
                        <!-- 含税金额 psmoney-->
                        <el-input v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2"
                          :ref="formOneValue.entityField"
                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" type="number"
                          min="0" @input="calculatePrice(2, scope.$index)">
                        </el-input>
                        <!-- 反扣比例 buckleProportion-->
                        <el-input
                          v-else-if="formOneValue.entityField == 'buckleProportion' && dataActionBox.actionType != 2"
                          :ref="formOneValue.entityField"
                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" type="number"
                          min="0" @input="backstepping(1, scope.$index)">
                          <el-button slot="append">%</el-button>
                        </el-input>
                        <!-- 反扣金额 buckleMoney-->
                        <el-input v-else-if="formOneValue.entityField == 'buckleMoney' && dataActionBox.actionType != 2"
                          :ref="formOneValue.entityField"
                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" type="number"
                          min="0" @input="backstepping(2, scope.$index)">
                        </el-input>
                        <!-- 备注 -->
                        <el-input v-else-if="formOneValue.entityField == 'remark' && dataActionBox.actionType != 2"
                          :ref="formOneValue.entityField"
                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" clearable
                          :disabled="formOneValue.isChange == 0" type="text"
                          v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                        <span v-else>{{ sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</span>
                      </template>
                    </el-table-column>

                  </el-table>
                </el-form>
              </div>
              <!-- 采购合同附件 -->
              <div v-if="scope.index == 1 && scope.row.isShowForm != 1">
                <el-form :inline="true" size="mini" ref="conFile">
                  <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                    <el-button type="primary" size="mini" @click="openUpFile">新增附件</el-button>
                    <el-button type="primary" size="mini" @click="delFile">删除附件</el-button>
                  </div>
                  <el-table size="mini" :data="sendDataInfo.uploadVoList" border :height="mxHeight" style="width: 100%">
                    <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                      <template slot-scope="scope">
                        <el-radio v-model="selectedDetailsIndex1" :label="scope.$index" border size="mini">
                          <i class="el-icon-thumb"></i>
                        </el-radio>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField"
                      :min-width="formOneValue.fieldWeight"
                      v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                      v-if="formOneValue.isShow == 1">
                      <template slot-scope="scope">
                        <!-- 备注 -->
                        <el-input v-if="formOneValue.entityField == 'conaRemark'" clearable
                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" type="text"
                          v-model.trim="sendDataInfo.uploadVoList[scope.$index][formOneValue.entityField]"></el-input>
                        <div class="demo-image__preview" v-else-if="formOneValue.entityField == 'fileUrl'">
                          <cusImage style="width: 20px; height: 20px" :src="imgUrl + '/' + scope.row.fileUrl"
                            :preview-src-list="[imgUrl + '/' + scope.row.fileUrl]">
                          </cusImage>

                        </div>
                        <span v-else>{{ sendDataInfo.uploadVoList[scope.$index][formOneValue.entityField] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form>
              </div>
            </div>
          </template>
        </v-tabs>
      </el-card>
      <!-- 尾部金额、按钮 -->
      <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
        @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
    </div>
    <!-- 打印 -->
    <printPlan ref="printPlan"></printPlan>
    <!-- 提取方案 -->
    <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
      :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
      <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth"
        @sendTitle="getExtractName" />
    </el-dialog>
    <!-- 检索方案 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
        @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 合同上传 -->
    <el-dialog title="上传合同" :visible.sync="dialogUp" width="600px" :modal-append-to-body='true' :append-to-body="true">
      <div>
        <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" ref="upload"
          :action="requesUrl + '/upload/fileupload'" :headers="token" :on-preview="handlePreview"
          :on-remove="handleRemove" :file-list="fileList" :limit="20" :on-success="handleAvatarSuccess"
          :auto-upload="false" :on-exceed="handleExceed" multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUp = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import VTabs from '../byComponents/vTabs.vue';
import VFoot from '../byComponents/vFoot.vue';
export default {
  name: "procurementContractAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    ExtractionScheme,
    VTabs,
    VFoot,
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 0,//自适应高度
      token: { token: sessionStorage.getItem("token") },
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "ltr",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      showTabs: "",//tab名称
      formDataList: [],//动态表单数据
      tabForm: [],//动态表单数据---采购合同表单
      mxForm: [],//动态明细数据
      footForm: [],//动态尾部数据
      dictionariesData: {},//所有下拉框的数据
      //新增、修改提交的数据
      sendDataInfo: {},
      defaultDetail: {},//明细数据
      selectedDetailsIndex: 0,//明细索引值
      DialogExtract: false,//提取方案弹框
      ppId: "pmId",//检索条件中获取该字段的值 明细查询id所传的也是该字段的值
      exTitle: "",//提取方案的名称
      exWidth: "90%",//提取方案的宽度
      DialogVisible: false,//检索方案弹框
      seTitle: "",//检索方案名称
      isShowDetail: false,//是否展示添加明细
      seId: "",//检索方案Id
      seType: "",//检索方案查询条件字段
      seWidth: "",//检索方案宽度
      parentSearchData: {},//检索方案补充的查询列表的查询条件
      dialogUp: false,//合同上传 采购合同附件弹框
      isChange: false,//判断是否禁用 是否有明细这个开关
      requesUrl: "",//接口地址
      imgUrl: "",//图片地址
      fileList: [],//上传合同的列表数据
      selectedDetailsIndex1: 0,//附件列表索引值
      fField: "",//获取焦点字段
      sField: "",//赋值字段
      selectedRow: [], // 当前已选择行
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // 明细监听
    "sendDataInfo.detailList": {
      handler: function (newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          this.sendDataInfo.totalMoney = 0;//总金额
          this.sendDataInfo.totalCount = 0;//总条目数
          this.sendDataInfo.totalNumber = 0;//总数量
          newValue.forEach((item, keys) => {
            this.sendDataInfo.totalMoney = this.isNullOrUd(item.psmoney) ? 0 : this.$common.getDecimalInfo(
              3,
              NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
            );
            this.sendDataInfo.totalNumber = this.isNullOrUd(item.num) ? 0 : this.$common.getDecimalInfo(
              1,
              NP.plus(this.sendDataInfo.totalNumber, item.num)
            );
          });
          this.sendDataInfo.totalCount = newValue.length;
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    getValue(val, type, fieldType, arr) {
      var str = ""
      if (fieldType == 'formatter') {
        if (arr) {
          JSON.parse(arr).forEach(item => {
            if (String(Number(item.value)) != NaN && item.value == val) {
              str = item.key
            } else if (String(Number(item.key)) != NaN && item.key == val) {
              str = item.value
            }
          })
        }
      } else {
        str = val || ""
      }
      return String(str)
    },
    //获取所有的下拉框的数据
    async getPartDictionariesData() {
      let responseData = await this.$http.getPartDictionariesData({ ids: [56] })
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    //动态获取 高度适配
    tabHeight(val) {
      this.mxHeight = val
    },
    //是否有明细
    changeOrder(e) {
      for (let key in this.sendDataInfo) {
        if (key == "detailList" || key == "uploadVoList") {
          this.sendDataInfo[key] = [];
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.sendDataInfo.applyTime = this.$moment().valueOf();
      this.sendDataInfo.conmCreater = this.$store.getters.getUserInfo.opmId;
      this.sendDataInfo.totalMoney = 0;
      this.sendDataInfo.totalCount = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.uploadVoList = [];
      this.sendDataInfo.detailList = [];
    },
    // 确定上传合同
    submitUpload() {
      this.$refs.upload.submit();
    },
    // 文件上传成功回调
    handleAvatarSuccess(res, file, fileList) {
      this.dialogUp = false;
      this.$message({
        message: "上传成功",
        type: "success",
      });
      var midArr = res.result;
      midArr.forEach((v) =>
        this.sendDataInfo.uploadVoList.push(JSON.parse(JSON.stringify(v)))
      );
    },
    handleClose(done) {
      this.$confirm("确认取消文件上传？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    //删除上传合同的数据的回调
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    //拦截限制上传个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 20 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //打开新增附件上传
    openUpFile() {
      this.fileList = [];
      this.dialogUp = true;
    },
    // 检索方案获取的数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        if (this.seType == "bgmName") {
          for (let key in val) {//明细数据赋值
            this.sendDataInfo.detailList[this.selectedDetailsIndex][key] = val[key];
          }
          this.$nextTick(() => {
            //跳转到指定的输入框
            this.tableNextFocus(this.fField, this.selectedDetailsIndex);
            //选中当行
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex]
            );
          });
        } else if (this.seType == "smName") {
          this.paramValue(val);//赋值字段
        } else {
          this.paramValue(val);//赋值字段
        }
      }
      this.DialogVisible = false;//关闭检索方案弹框
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= this.inputel.length - 1) {
        if (this.sendDataInfo.detailList.length > 0) {
        }
        this.addDetail("sendDataInfo");
        return;
      }
      var aindex = index + 1;
      if (
        this.inputel[aindex].value != "" ||
        this.inputel[aindex].disabled
      ) {
        this.nextFocus(aindex);
        return;
      }
      this.inputel[aindex].focus();
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == "") {
          this.inputel[index].focus();
          break;
        }
      }
    },
    // 表格切换焦点方法
    tableNextFocus(field, index) {
      if (field == "keydown") {
        if (this.sendDataInfo.detailList[index + 1] != undefined) {
          this.$refs["bgmName"][index + 1].focus();
          this.selectedDetailsIndex = index + 1;
          this.$nextTick(() => {
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex]
            );
          });
          return;
        }
        //新增明细
        this.addDetail("sendDataInfo");
        return;
      }
      this.$refs[field][index].focus();
    },
    //关闭提取、检索方案弹框关闭 创建键盘事件
    closeChild() {
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item];
      });
      this.$nextTick(() => {
        this.nextFocus(this.selectedDetailsIndex);
      });
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField, fField) {
      if (type == "salesName") {
        if (
          this.sendDataInfo.smId == undefined ||
          this.sendDataInfo.smId == ""
        ) {
          return this.$message({
            message: "请先选择供应商",
            type: "error",
          });
        } else {
          this.parentSearchData.unitId = this.sendDataInfo.smId;
        }
      }
      this.DialogVisible = true;//打开弹框
      removeEventListener("keyup", this.keyUp);//移除键盘事件
      this.seId = sId;//检索方案Id
      this.seType = type;
      this.sField = sField;
      this.fField = fField;
      if (type == "bgmName") {
        this.selectedDetailsIndex = index;//明细索引值
        this.parentSearchData[type] = this.sendDataInfo.detailList[this.selectedDetailsIndex][type];
        this.parentSearchData['smId']=this.sendDataInfo.smId
        this.parentSearchData['coId']=this.sendDataInfo.coId
        return;
      }
      this.parentSearchData[type] = this.sendDataInfo[type];
    },
    //检索方案宽度
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    //检索方案名称
    getSearchName(e) {
      this.seTitle = e;
    },
    // 触发提取方案
    openExComponents(e) {
      this.exId = e;//提取方案Id
      this.DialogExtract = true;//打开弹框
      removeEventListener("keyup", this.keyUp);//移除键盘事件
    },
    // 获取 提取单数据
    async getExData(val) {
      for (let key in val) {
        if (key == "arrlistbychen") {
          this.sendDataInfo.detailList = val.arrlistbychen;
          this.sendDataInfo.detailList.forEach((info, index) => {
            // 计算整件数量
            this.sendDataInfo.detailList[index].wholeNum = Math.floor(
              NP.divide(
                parseFloat(info.num),
                parseFloat(info.packingSpec)
              )
            );
            //计算零散数量
            this.sendDataInfo.detailList[index].scatNum =
              parseFloat(info.num) -
              parseFloat(info.wholeNum) * parseFloat(info.packingSpec);
            //计算税额
            this.sendDataInfo.detailList[index].taxAmount =
              this.$common.getDecimalInfo(
                3,
                NP.minus(
                  parseFloat(info.psmoney),
                  parseFloat(info.money)
                )
              );
            // 计算件数 采数/包装单位
            if (
              parseFloat(info.packingSpec) <= 0 ||
              info.packingSpec == ""
            ) {
              this.sendDataInfo.detailList[index].pieceNum = 0;
            } else {
              this.sendDataInfo.detailList[index].pieceNum =
                this.$common.getDecimalInfo(
                  1,
                  NP.divide(
                    parseFloat(info.num),
                    parseFloat(info.packingSpec)
                  )
                );
            }
          });
        } else {
          this.sendDataInfo[key] = val[key];
        }
      }
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
      this.DialogExtract = false;
      this.$nextTick(() => {
        this.selectedDetailsIndex = 0;
        this.tableNextFocus("psrgdRecnumber", 0);
        let refsElTable = this.$refs.mxTableRef;
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(
          this.sendDataInfo.detailList[this.selectedDetailsIndex]
        );
      });
    },
    //提取方案宽度
    getExWidth(e) {
      this.exWidth = e + "%";
    },
    //提取方案名称
    getExtractName(e) {
      this.exTitle = e;
    },
    //打印
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        console.log("选中的数据", this.actionData);
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    // 监听键盘事件
    keyUp(e) {
      if (e.key == "F1") {
        // 右键新增明细
        e.preventDefault();
        this.addDetail("sendDataInfo");
        return;
      } else if (e.key == "F2") {
        e.preventDefault();
        this.deleteDetails();
      } else if (e.keyCode == 40) {
        // 下键
        // 表格为空，不执行下方
        if (this.sendDataInfo.detailList.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 如果当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (
            this.selectedDetailsIndex ==
            this.sendDataInfo.detailList.length - 1
          ) {
            // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDetailsIndex = 0;
          } else {
            // 正常递增
            this.selectedDetailsIndex++;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex],
              false
            );
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.detailList[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      } else if (e.keyCode == 38) {
        // 上键
        if (this.sendDataInfo.detailList.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (this.selectedDetailsIndex == 0) {
            // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDetailsIndex =
              this.sendDataInfo.detailList.length - 1;
          } else {
            // 正常递减
            this.selectedDetailsIndex--;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex],
              false
            );
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.detailList[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      }
    },

    // 表格方法
    rowClassName({ row, rowIndex }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },

    // 选中行底色逻辑
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
    },

    // 明细表格点击选中
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef; // 获取表格对象
      let findRow = {};
      this.selectedDetailsIndex = row.rowIndex;
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },

    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedRow = rows; // 保存已选择行
    },
    //穿透
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId);
    },
    // 计算价格
    calculatePrice(cate = 1, index) {
      var info = this.sendDataInfo["detailList"][index];
      if (info.num <= 0) {
        this.$message({
          message: "请先填写数量",
          type: "error",
        });
        // return false;
      }

      switch (cate) {
        case 1: // 通过含税价格计算
          this.sendDataInfo["detailList"][index].inRate = this.isNullOrUd(info.inRate) ? 0 : info.inRate;
          this.sendDataInfo["detailList"][index].psprice = this.isNullOrUd(info.psprice) ? 0 : info.psprice;
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.detailList[index].psmoney = info.num === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.num));
          // 计算金额 含税金额/(税率/100+1)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.detailList[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)));

          // var midmoney = NP.divide(this.sendDataInfo.detailList[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
          this.sendDataInfo.detailList[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.detailList[index].price = info.num === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.num));
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.detailList[index].psmoney, this.sendDataInfo.detailList[index].money));
          //计算反扣金额
          if (this.sendDataInfo["detailList"][index].buckleProportion !== "" && this.sendDataInfo["detailList"][index].buckleProportion != 0) {//反扣比例
            this.sendDataInfo["detailList"][index].buckleMoney =
              this.$common.getDecimalInfo(
                3,
                NP.times(
                  parseFloat(info.buckleProportion / 100),
                  parseFloat(info.psmoney)
                )
              );
          }
          break;
        case 2: // 通过含税金额计算
          this.sendDataInfo["detailList"][index].inRate = this.isNullOrUd(info.inRate) ? 0 : info.inRate;
          this.sendDataInfo["detailList"][index].packingSpec = this.isNullOrUd(info.packingSpec) ? 0 : info.packingSpec;
          this.sendDataInfo["detailList"][index].psmoney = this.isNullOrUd(info.psmoney) ? 0 : info.psmoney;

          // 计算含税价格  含税金额 / 数量
          this.sendDataInfo.detailList[index].psprice = info.num === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.psmoney, info.num));
          // 计算总金额 含税金额/(税率/100+1)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
          // var midmoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
          this.sendDataInfo.detailList[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.detailList[index].price = info.num === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.num));
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, this.sendDataInfo.detailList[index].money));

          // 计算整件数量
          this.sendDataInfo.detailList[index].wholeNum = Math.floor(NP.divide(info.num, Number(info.packingSpec)));
          //计算零散数量
          this.sendDataInfo.detailList[index].scatNum = info.num - this.sendDataInfo.detailList[index].wholeNum * Number(info.packingSpec);
          //计算反扣金额
          if (this.sendDataInfo["detailList"][index].buckleProportion !== "" && this.sendDataInfo["detailList"][index].buckleProportion != 0) {//反扣比例
            this.sendDataInfo["detailList"][index].buckleMoney =
              this.$common.getDecimalInfo(
                3,
                NP.times(
                  parseFloat(info.buckleProportion / 100),
                  parseFloat(info.psmoney)
                )
              );
          }
          break;
        default:
          // 通过数量计算
          this.sendDataInfo["detailList"][index].psprice = this.isNullOrUd(info.psprice) ? 0 : info.psprice;
          this.sendDataInfo["detailList"][index].price = this.isNullOrUd(info.price) ? 0 : info.price;
          this.sendDataInfo["detailList"][index].packingSpec = this.isNullOrUd(info.packingSpec) ? 0 : info.packingSpec;

          // 计算含税金额 含税价格*数量
          var midmoney = info.num === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.num))
          this.sendDataInfo.detailList[index].psmoney = this.$common.getDecimalInfo(3, midmoney);
          // 计算总金额 含税金额/(税率/100+1)
          this.sendDataInfo.detailList[index].money = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.detailList[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)));
          // 计算整件数量
          this.sendDataInfo.detailList[index].wholeNum = Math.floor(NP.divide(info.num, Number(info.packingSpec)));
          //计算零散数量
          this.sendDataInfo.detailList[index].scatNum = NP.minus(info.num, NP.times(this.sendDataInfo.detailList[index].wholeNum, Number(info.packingSpec)));
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.detailList[index].psmoney, this.sendDataInfo.detailList[index].money));

          //计算零散数量
          //  this.sendDataInfo.detailList[index].scatNum = info.num - info.wholeNum * Number(info.packingSpec);
          // 计算件数 采数/包装单位
          if (
            parseFloat(info.packingSpec) <= 0 ||
            info.packingSpec == ""
          ) {
            this.sendDataInfo.detailList[index].pieceNum = 0;
          } else {
            this.sendDataInfo.detailList[index].pieceNum =
              this.$common.getDecimalInfo(
                1,
                NP.divide(info.num, info.packingSpec)
              );
          }
          //计算反扣金额
          if (this.sendDataInfo["detailList"][index].buckleProportion !== "" && this.sendDataInfo["detailList"][index].buckleProportion != 0) {//反扣比例
            this.sendDataInfo["detailList"][index].buckleMoney =
              this.$common.getDecimalInfo(
                3,
                NP.times(
                  parseFloat(info.buckleProportion / 100),
                  parseFloat(info.psmoney)
                )
              );
          }
          break;
      }
    },
    //计算
    backstepping(cate, index) {
      var info = this.sendDataInfo["detailList"][index];
      switch (cate) {
        case 1: // 反扣比例
          // 反扣金额 反扣比例*含税金额
          this.sendDataInfo["detailList"][index].buckleMoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(
                parseFloat(info.buckleProportion / 100),
                parseFloat(info.psmoney)
              )
            );
          break;
        case 2: // 反扣金额
          // 反扣比例  反扣金额 / 含税金额
          this.sendDataInfo["detailList"][index].buckleProportion =
            this.$common.getDecimalInfo(3,
              (this.$common.getDecimalInfo(
                2,
                NP.divide(
                  parseFloat(info.buckleMoney),
                  parseFloat(info.psmoney)
                )
              ) * 100
              ))
          break;
        default:
          break;
      }
    },
    //判断为null或者空值时给初始值
    isNullOrUd(num) {
      if (typeof num === 'object' || isNaN(parseFloat(num))) {
        return true
      } else {
        return false
      }
    },
    //关闭窗口
    initActionBox(sendDataInfo) {
      this.$confirm(
        "确定取消" + this.dataActionBox.boxTitle + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$emit("drawerCancel", 0);
          this.init();
        })
        .catch(() => { });
    },
    //初始化数据
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }
      this.sendDataInfo.conmCreater = this.$store.getters.getUserInfo.opmId;
      this.sendDataInfo.totalMoney = 0;
      this.sendDataInfo.totalCount = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.uploadVoList = [];
      this.sendDataInfo.detailList = [];
    },
    // 新增明细
    addDetail(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          var info = JSON.parse(JSON.stringify(this.defaultDetail));
          this.sendDataInfo.detailList.push(info);
          this.$nextTick(() => {
            this.selectedDetailsIndex = Number(
              this.sendDataInfo.detailList.length - 1
            );
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex]
            );
          });
        } else {
          return this.$message({
            message: "请完善信息",
            type: "error",
          });
        }
      });
    },
    //删除明细
    deleteDetails() {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.sendDataInfo.detailList.splice(
            this.selectedDetailsIndex,
            1
          );
          this.$nextTick(() => {
            if (this.sendDataInfo.detailList.length > 1) {
              this.selectedDetailsIndex = Number(
                this.selectedDetailsIndex - 1
              );
              this.tableNextFocus("bgmName", this.selectedDetailsIndex);
              let refsElTable = this.$refs.mxTableRef;
              refsElTable.clearSelection();
              refsElTable.toggleRowSelection(
                this.sendDataInfo.detailList[
                this.selectedDetailsIndex
                ]
              );
            } else {
              this.selectedDetailsIndex = 0;
            }
          });
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => { });
    },
    //第一次进入弹框 数据赋值
    openBox() {
      this.$common.routeLog('procurementContractAction')//记录控制台打印页面（前端检查使用）
      this.dataActionBox.actionType = this.actionData.cate;//类型：0新增 1修改 2查看
      this.formDataList = this.actionData.formData;//动态表单
      this.showTabs = this.actionData.formData[0].jciName;//tab标题
      this.filterMainField();
      this.init()//初始化数据
      this.getPartDictionariesData()//拿字典项
      var oldData = this.actionData.oldData;//数据
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        this.isChange = false;
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        this.isChange = true;//判断是否有明细这个字段禁用
        for (let key in oldData) {//数据赋值
          this.$set(this.sendDataInfo, key, oldData[key])
        }
        if (this.sendDataInfo.isDetail == 1) {
          this.isShowDetail = true;
        } else if (this.sendDataInfo.isDetail == 0) {
          this.isShowDetail = false;
        } else {
          this.isShowDetail = true;
        }
      } else if (this.dataActionBox.actionType == 2) {
        this.dataActionBox.boxTitle = "查看信息";
        this.dataActionBox.openMode = "rtl";
        this.isChange = true;//判断是否有明细这个字段禁用
        for (let key in oldData) {//数据赋值
          this.$set(this.sendDataInfo, key, oldData[key])
        }
        if (this.sendDataInfo.isDetail == 1) {
          this.isShowDetail = true;
        } else if (this.sendDataInfo.isDetail == 0) {
          this.isShowDetail = false;
        } else {
          this.isShowDetail = true;
        }
      }
      //高度适配
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
          this.initFocus();
        }, 16.7)
      });
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);//动态表单
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));//动态明细
          this.mxForm.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.defaultDetail, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.defaultDetail, item2, "")
              })
            } else {
              this.$set(this.defaultDetail, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));//动态尾部
        }
      });
      //动态表单
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1)
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = [{ entityField: "uploadVoList" }, { entityField: "detailList" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {//动态表单实现赋值
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.$set(this.sendDataInfo, "conmCreater", this.$store.getters.getUserInfo.opmId)

    },
    //--------------------------------------------------------
    //保存
    async sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          if (
            this.isShowDetail == true &&
            this.sendDataInfo.detailList.length == 0
          ) {
            this.$message({
              message: "明细不能为空",
              type: "error",
            });
            return;
          }
          this.sub();
        } else {
          return this.$message({
            message: "请完善信息",
            type: "error",
          });
        }
      });
    },
    //保存调用接口
    async sub() {
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      if (this.isShowDetail == false) {
        sendData.detailList = [];
        sendData.isDetail = 0;
      } else {
        sendData.isDetail = 1;
      }
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.addContract(sendData);
      } else {
        var responseData = await this.$http.editContract(sendData);
      }
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel", 1);
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    //删除附件
    delFile() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.sendDataInfo.uploadVoList.splice(
            this.selectedDetailsIndex1,
            1
          );
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => { });
    },
    //获取图片存取的根路径
    imgurl() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },



  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.imgurl();
    this.$nextTick(() => {
      this.openBox();
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // addEventListener('keydown', this.keyDown)
    addEventListener("keyup", this.keyUp); //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener("keyup", this.keyUp);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.ellink {
  width: 263px;
  margin-left: -76px;
  margin-top: 10px;
}
</style>